import { useCallback } from 'react';
import * as Cesium from 'cesium';

export function useCartesianUtils(
  viewerRef: React.MutableRefObject<Cesium.Viewer | null>,
  modelClockWindowRef: React.MutableRefObject<any>,
) {
  const pickCartesian = useCallback((
    v: Cesium.Viewer,
    position: Cesium.Cartesian2
  ): Cesium.Cartesian3 | undefined => {
    let cartesian = v.camera.pickEllipsoid(position, v.scene.globe?.ellipsoid);
    if (!cartesian && v.scene.mode === Cesium.SceneMode.SCENE3D && v.scene.globe) {
      const ray = v.camera.getPickRay(position);
      if (ray) {
        cartesian = v.scene.globe.pick(ray, v.scene);
      }
    }
    return cartesian || undefined;
  }, []);

  const getDefaultModelEpoch = useCallback((): number => {
    const nowSec = Date.now() / 1000;
    const win = modelClockWindowRef.current;
    if (!win) return nowSec;
    return win.startEpoch;
  }, []);

  const clampEpochToModelWindow = useCallback((epochSec: number): number => {
    const win = modelClockWindowRef.current;
    if (!win) return epochSec;
    return Math.min(Math.max(epochSec, win.startEpoch), win.endEpoch);
  }, []);

  return {
    pickCartesian,
    getDefaultModelEpoch,
    clampEpochToModelWindow,
  };
}
